import { close, open } from './modal';
import { submit } from './submit';

export const newResultForm = {
  open,
  close,
  submit,
};
